import { render, staticRenderFns } from "./SpecialAndExtraordinaryExpenses.vue?vue&type=template&id=0f4cfd9f"
import script from "./SpecialAndExtraordinaryExpenses.vue?vue&type=script&lang=ts"
export * from "./SpecialAndExtraordinaryExpenses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports